import React, { Children } from 'react';
import { motion } from 'framer-motion';
import { Frown, XCircle } from 'lucide-react';
const containerVariants = {
  hidden: {
    opacity: 0
  },
  visible: {
    opacity: 1,
    transition: {
      staggerChildren: 0.2
    }
  }
};
const itemVariants = {
  hidden: {
    opacity: 0,
    x: -20
  },
  visible: {
    opacity: 1,
    x: 0,
    transition: {
      duration: 0.5
    }
  }
};
export function ProblemSection() {
  return <section className="bg-black py-16 px-4" data-id="element-106">
      <div className="max-w-7xl mx-auto" data-id="element-107">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-10 items-center" data-id="element-108">
          {/* Text Content */}
          <motion.div variants={containerVariants} initial="hidden" whileInView="visible" viewport={{
          once: true,
          margin: '-100px'
        }} data-id="element-109">
            <motion.h2 variants={itemVariants} className="font-heading text-3xl md:text-4xl font-bold text-white mb-6 leading-tight" data-id="element-110">
              ¿Por qué tus anuncios dejan de funcionar en una semana?
            </motion.h2>

            <motion.p variants={itemVariants} className="font-body text-lg text-gray-300 mb-8 leading-relaxed" data-id="element-111">
              Probaste ChatGPT y el texto suena a robot. Probaste Jasper y no
              conecta con tu avatar.{' '}
              <strong className="text-neon-red" data-id="element-112">
                Tus creativos se queman cada pocos días
              </strong>{' '}
              y no tenés un sistema para reemplazarlos estratégicamente.
            </motion.p>

            <motion.div variants={containerVariants} className="space-y-4" data-id="element-113">
              {['Mis creativos se saturan en 3 días y no sé qué probar después.', 'Le pido copy a la IA y parece genérico, sin vida.', 'Lanzo anuncios sin saber si atacar el dolor, el deseo o el FOMO.'].map((bullet, idx) => <motion.div key={idx} variants={itemVariants} className="flex items-start gap-4 bg-premium-mid p-4 rounded-lg border border-neon-red/30 shadow-sm glow-red" data-id="element-114">
                  <XCircle className="w-6 h-6 text-neon-red flex-shrink-0 mt-0.5" data-id="element-115" />
                  <p className="font-body text-gray-200 font-medium" data-id="element-116">
                    {bullet}
                  </p>
                </motion.div>)}
            </motion.div>
          </motion.div>

          {/* Image Replacement */}
          <motion.div initial={{
          opacity: 0,
          scale: 0.9
        }} whileInView={{
          opacity: 1,
          scale: 1
        }} transition={{
          duration: 0.6
        }} viewport={{
          once: true
        }} className="relative" data-id="element-117">
            <div className="absolute inset-0 bg-gradient-to-tr from-neon-red/20 to-transparent rounded-2xl -z-10" data-id="element-118" />
            <div className="rounded-2xl overflow-hidden border border-neon-red/30 shadow-xl glow-red relative" data-id="element-119">
              <div className="absolute inset-0 bg-neon-red/5 mix-blend-overlay pointer-events-none" data-id="element-120" />
              <img src="https://i.postimg.cc/j5YYG9pr/2.webp" alt="Fatiga creativa y caída de resultados" className="w-full h-auto object-cover" data-id="element-121" />
            </div>
          </motion.div>
        </div>
      </div>
    </section>;
}